import React from 'react';
import { useLanguage } from '@/language/LanguageContext';

export const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { t } = useLanguage();

  return (
    <footer className="bg-background border-t border-border py-8 px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          {/* Logo */}
          <a
            href="#"
            className="text-foreground font-medium text-lg tracking-tight hover:opacity-70 transition-opacity"
          >
            isifu.dev
          </a>

          {/* Copyright */}
          <p className="text-muted-foreground text-sm font-light">
            © {currentYear} {t('footer.rights')}
          </p>

          {/* Back to top */}
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="text-muted-foreground text-sm font-light hover:text-foreground transition-colors"
          >
            {t('footer.backToTop')}
          </button>
        </div>
      </div>
    </footer>
  );
};
